import { motion, useReducedMotion } from "framer-motion";

export interface SparklesProps {
  /** Toggles the animation loop and visibility. When false, nothing renders. */
  active: boolean;
}

/** Fixed positions tuned to frame the 1st-place card without overlapping
 * the avatar or medal. Values are percentages relative to the parent. */
const PARTICLES = [
  { top: "8%", left: "6%", size: 18, delay: 0 },
  { top: "14%", left: "88%", size: 14, delay: 0.6 },
  { top: "62%", left: "4%", size: 12, delay: 1.1 },
  { top: "70%", left: "92%", size: 16, delay: 0.3 },
  { top: "38%", left: "96%", size: 10, delay: 1.6 },
] as const;

/** 5 dorados SVG sparkles floating around the parent. Parent must be
 * positioned (relative/absolute). The component is purely decorative
 * so it's marked aria-hidden. */
export function Sparkles({ active }: SparklesProps) {
  const reduced = useReducedMotion();
  if (!active) return null;

  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-visible"
    >
      {PARTICLES.map((p, i) => (
        <motion.svg
          key={i}
          viewBox="0 0 24 24"
          width={p.size}
          height={p.size}
          style={{
            position: "absolute",
            top: p.top,
            left: p.left,
            color: "#fbbf24",
            filter: "drop-shadow(0 0 6px rgba(251,191,36,0.55))",
          }}
          initial={{ opacity: 0, scale: 0.4, rotate: 0 }}
          animate={
            reduced
              ? { opacity: 0.8, scale: 1 }
              : {
                  opacity: [0, 1, 0.4, 0],
                  scale: [0.4, 1.1, 0.9, 0.4],
                  rotate: [0, 45, 90, 180],
                }
          }
          transition={
            reduced
              ? { duration: 0 }
              : {
                  duration: 2.4,
                  delay: p.delay,
                  repeat: Infinity,
                  ease: "easeInOut",
                }
          }
        >
          <path
            d="M12 2 L13.8 9.2 L21 11 L13.8 12.8 L12 20 L10.2 12.8 L3 11 L10.2 9.2 Z"
            fill="currentColor"
          />
        </motion.svg>
      ))}
    </div>
  );
}
